import { ChatsCircle } from "@phosphor-icons/react";
import { useEffect } from "react";
import YTRepliesConsolePair from "@/components/YTRepliesConsolePair";
import YTRepliesRateLimitsPair from "@/components/YTRepliesRateLimitsPair";

// Oct 2026 (Randy) — the YouTube Replies console used to live at the bottom of
// the Chats tab, where "the feature is so huge, and it's sort of hidden". It now
// owns a tab. The old tab id `conversations` still resolves here (installed
// home-screen icons have it baked into their manifest), so nothing that was
// pinned to a phone breaks.
// Oct 17, 2026 (Randy — "I don't get toasts inside of mobile in the YT Digital
// twin"). Toasts are hidden on phones platform-wide (his Jul 2026 call: they
// covered the macro watch screen), with ONE opt-in — `body.ytre-toasts`, see
// index.css. YtreTab already opts the capture tab back in; the replies console
// never did, so on a phone the Draft-unresponded results, skip reasons and post
// failures all arrived as toasts nobody could see.
//
// The opt-in belongs HERE, on the tab, gated on `active` — not on the console
// card. The silo dashboard keep-alives every tab under display:none, so a
// card-level effect fires for all three mounted consoles on every tab and
// quietly re-enables toasts across the whole silo. Caught in testing.
let _ytToastMounts = 0;

function useMobileToastsWhileActive(active) {
  useEffect(() => {
    if (!active) return undefined;
    _ytToastMounts += 1;
    document.body.classList.add("ytre-toasts");
    return () => {
      _ytToastMounts -= 1;
      if (_ytToastMounts <= 0) {
        _ytToastMounts = 0;
        document.body.classList.remove("ytre-toasts");
      }
    };
  }, [active]);
}

export default function YtTwinTab({ siloId, siloSlug, active = false }) {
  useMobileToastsWhileActive(active);
  return (
    <div className="space-y-6" data-testid="yt-twin-tab">
      <div>
        <h2 className="font-serif-display text-3xl text-[#1C1B1A] flex items-center gap-2">
          <ChatsCircle size={24} weight="duotone" className="text-[#4A5D4E]" />
          YT Digital Twin
        </h2>
        <p className="text-sm text-[#6B6A68] mt-1 max-w-2xl">
          Your twin answering real YouTube comments — both channels, their drafts,
          their queues and their rate limits. Everything it sends here is written
          from your silo's own library, in your voice.
        </p>
      </div>

      {/* Jul 30, 2026 (Randy pt89c-xxxviii) — both channels via a mobile-safe
          channel-tab pair (Channel 1 · Channel 2 with a SHARED collapse
          chevron). Per-channel state survives tab flips via display:none. */}
      <div>
        <YTRepliesConsolePair siloId={siloId} siloSlug={siloSlug} />
        <YTRepliesRateLimitsPair siloId={siloId} />
      </div>
    </div>
  );
}
